function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.80957 0.666626L1.33691 5.1471L1.30176 5.17835C1.30176 5.17835 1.19238 5.29163 1.08301 5.45178C0.977539 5.61194 0.833008 5.82288 0.833008 6.15491V13.1549C0.833008 13.9791 1.50879 14.6549 2.33301 14.6549H13.333C14.1572 14.6549 14.833 13.9791 14.833 13.1549V6.15491C14.833 5.51428 14.3525 5.18616 14.2432 5.11975L7.80957 0.666626ZM7.80957 1.88147L13.2666 5.65881L7.83301 9.42053L2.37598 5.64319L7.80957 1.88147ZM1.83301 6.48303L7.83301 10.6393L13.833 6.48303V13.1549C13.833 13.4362 13.6143 13.6549 13.333 13.6549H2.33301C2.05176 13.6549 1.83301 13.4362 1.83301 13.1549V6.48303Z",
  fill: "#23335B"
});

var SvgEnvelop = function SvgEnvelop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnvelop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/envelop.132d96b3.svg";
export { ForwardRef as ReactComponent };